// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__14ciX","name":"ConsentHeader_name__tTUUV","birthday":"ConsentHeader_birthday__3xbiH","skeleton":"ConsentHeader_skeleton__9ANti"};